var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ statusNotAllow: _vm.productStatus !== 'S' },attrs:{"id":"app"}},[(_vm.productStatus !== 'S')?_c('div',{staticClass:"warnWrapNotify"},[_vm._v(_vm._s(_vm.mes))]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }